const k = async (e, t) => !!(await window.Fitle.getPluginInfos(e, t)).eligible, E = async (e) => {
    try {
      const t = await fetch(e);
      if (t.ok)
        return await t.json();
      throw new Error(`HTTP Error: ${t.status}`);
    } catch (t) {
      throw new Error(`${t.message} (GET: ${e})`);
    }
  }, m = async (e, t) => {
    try {
      const r = await fetch(e, {
        body: JSON.stringify(t),
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST"
      });
      if (!r.ok)
        throw new Error(`Error HTTP: ${r.status}`);
    } catch (r) {
      throw new Error(`${r.message} (POST: ${e})`);
    }
  }, f = (e, t, r, n, i) => {
    r && n ? console.warn(`[Fitle Debug] ${n}`) : window.Fitle.sendSentryError(
      {
        ...e,
        message: `[${t && t.clientName ? t.clientName : window.location.host}] ${e.message}`
      },
      {
        _clientId: t == null ? void 0 : t.id,
        _clientName: t == null ? void 0 : t.clientName,
        _data: i && JSON.stringify(i),
        _errorStack: e.stack,
        _url: window.location.href
      }
    );
  }, p = () => localStorage.getItem("ftl_device_id"), d = () => {
    window.getFtlCustomerId = p;
  }, $ = (e, t, r) => {
    m("https://tracking.fitle.com/events", e).catch((n) => {
      f(
        n,
        t,
        r,
        `Something went wrong with ${e.event} event, check if the event format is correct.`,
        e
      );
    });
  }, l = {}, v = async (e) => {
    if (e in l)
      return l[e];
    try {
      const t = await E(`https://api.fitle.com/clients/${e}/information`);
      return l[e] = t, t;
    } catch (t) {
      throw new Error(`Error occurred while fetching client information: ${t.message}`);
    }
  }, F = async (e, t, r) => {
    const n = window.ftlclientId, i = p(), s = {
      client_id: n,
      event: e,
      tracking_id: i
    };
    switch (e) {
      case "cart":
        {
          const { product_id: o, size: c } = t;
          if (await k(n, o))
            s.product_id = o, s.size = c;
          else
            return null;
        }
        break;
      case "transaction_end":
        {
          const { order_id: o, products: c, total_price: u } = t, g = c.map(({ id: _ }) => _), y = c[0].currency;
          s.order_id = o, s.paid_price = {
            currency: y,
            price: u
          }, s.product_ids = g, s.products = c, s.transaction_id = "new integration";
        }
        break;
      default:
        return null;
    }
    let a;
    try {
      a = await v(n);
    } catch (o) {
      f(o, a, r);
    }
    try {
      $(s, a, r);
    } catch (o) {
      f(o, a, r);
    }
  }, h = (e, t, r, n = !1) => {
    switch (e) {
      case "event":
        F(t, r, n);
    }
  }, w = () => {
    window.ftltag = h, window.ftldataLayer.forEach((e) => {
      e[0] === "config" && (window.ftlclientId = parseInt(e[1])), h(...e);
    });
  };
  if (window.Fitle)
    w(), d();
  else {
    let e;
    for (const t of window.ftldataLayer)
      if (t[0] === "env" && t[1] === "staging") {
        e = "https://sdk-staging.fitle.com/sdk.js";
        break;
      }
    for (const t of window.ftldataLayer)
      if (t[0] === "config") {
        window.ftlclientId = parseInt(t[1]);
        break;
      }
    if (e || (e = "https://sdk.fitle.com/sdk.js"), typeof define == "function" && define.amd)
      requirejs([e], function() {
        w(), d();
      });
    else {
      const t = document.createElement("script");
      t.src = e, t.async = !0, t.onload = async function() {
        if (!window.ftlclientId)
          return null;
        await window.Fitle.setup(window.ftlclientId), w(), d();
      }, document.head.appendChild(t);
    }
  }